import React, { useState, useEffect } from "react";
import styled, { css } from "styled-components";

const Row = styled.tr`
  cursor: pointer;
  ${(props) =>
    props && props.selected
      ? css`
          background-color: #b5ffc7;
        `
      : css``};
`;

export default function MatrixFilter({ matrices, onChange, matrix }) {
  return (
    <div>
      <table className="table table-condensed">
        <thead>
          <tr>
            <th>Matrix</th>
          </tr>
        </thead>
        <tbody>
          {matrices.map((m) => (
            <Row selected={matrix && m.id === matrix.id} onClick={() => onChange(m)}>
              <td>{m.name}</td>
            </Row>
          ))}
        </tbody>
      </table>
    </div>
  );
}
